import { render, staticRenderFns } from "./employment-address-add.vue?vue&type=template&id=36b6a526&scoped=true"
import script from "./employment-address-add.vue?vue&type=script&lang=js"
export * from "./employment-address-add.vue?vue&type=script&lang=js"
import style0 from "./employment-address-add.vue?vue&type=style&index=0&id=36b6a526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b6a526",
  null
  
)

export default component.exports